export const GET_INCOME_RECONCILIATION_PAGE = `
  query getConciliacionIngresosPage($input: ConciliacionIngresosPageInput!) {
    getConciliacionIngresosPage(input: $input) {
      items {
        transactionId
        banco
        fecha
        monto
        estado
        comision
        vinculoEncontrado
        tipoOrden
        estadoVinculo
        deudorNombre
        deudorTipo
        numerosOI
        tiposIngreso
        monedaOI
        hasAccountStatement
      }
      nextToken
      hasMore
    }
  }
`;

export const GET_INCOME_RECONCILIATION_DETAIL = `
  query getConciliacionIngresoDetalle($transactionId: ID!) {
    getConciliacionIngresoDetalle(transactionId: $transactionId) {
      transactionId
      tipoVinculo
      vinculoEncontrado
      cobranza {
        id
        estado
        fechaEfectiva
        listaOI {
          id estado numberOI tipoIngreso categoriaIngreso subcategoriaIngreso
          moneda monto montoPagado
          deudor { id nombre tipo }
          accountStatement {
            id clientId clientName period startDate endDate dueDate createdAt
          }
        }
      }
      egreso {
        id fechaPago fechaReprogramacion estado tipoOrden
        proveedor { nombreProveedor }
        egresos { id file fileExtend codigo monto observaciones }
      }
      movimientoIntraday {
        id estado monto tipoCambio comision fechaEfectiva fechaReprogramacion
        cuentaCargo { nombre tipo }
        cuentaDestino { nombre tipo }
      }
    }
  }
`;

export const GET_INCOME_RECONCILIATION_PENDING_COLLECTIONS = `
  query getConciliacionIngresoCobrosPendientes($transactionId: ID!) {
    getConciliacionIngresoCobrosPendientes(transactionId: $transactionId) {
      transactionId
      orders {
        id
        numberOI
        accountStatement {
          id clientId clientName period startDate endDate dueDate createdAt
        }
        listaPagosPendientes {
          id numeroFile numeroPI descripcion fechaOperacionFile
          total totalPagado pendienteCobrar cobradoSAF montoCobrar
        }
      }
    }
  }
`;

export const GET_INCOME_RECONCILIATION_ORDER_CANDIDATES = `
  query getIncomeReconciliationOrderCandidates(
    $input: IncomeReconciliationOrderCandidatesInput!
  ) {
    getIncomeReconciliationOrderCandidates(input: $input) {
      items {
        id
        montoPagado
        numberOI
        estado
        fechaRecepcion
        tipoIngreso
        categoriaIngreso
        subcategoriaIngreso
        moneda
        monto
        deudor { nombre tipo }
      }
      nextToken
      hasMore
    }
  }
`;
